module.exports = __webpack_public_path__ + "img/ywbk_04.9cd3c43f.png";